// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1kbN5","cell":"ColumnAccessor_cell__1GHfJ","firstCellAccent":"ColumnAccessor_firstCellAccent__1z2S8"};